import React from 'react';
import { Clock, BookOpen, Award } from 'lucide-react';

const LearningStats = () => {
  const stats = [
    { icon: Clock, value: '24h', label: 'Learning Time' },
    { icon: BookOpen, value: '12', label: 'Active Courses' },
    { icon: Award, value: '8', label: 'Certificates' }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {stats.map((stat, index) => (
        <div key={index} className="bg-white rounded-xl shadow-sm p-6">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-indigo-100 rounded-full">
              <stat.icon className="h-6 w-6 text-indigo-600" />
            </div>
            <div>
              <p className="text-2xl font-bold">{stat.value}</p>
              <p className="text-sm text-gray-600">{stat.label}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LearningStats;